// Long tasks (>= 50 ms) of the main thread, to tell how much of a request's wait the browser itself was busy.
// Only Chromium (the app and Chrome) reports them; elsewhere the busy time is not shown.
export const LONG_TASKS_SUPPORTED = PerformanceObserver.supportedEntryTypes.includes('longtask');
const KEEP_MS = 60_000; // longer than any request waits

const longTasks = [];
const observer = new PerformanceObserver((list) => {
  longTasks.push(...list.getEntries());
});
if (LONG_TASKS_SUPPORTED) {
  observer.observe({ type: 'longtask' });
}

// ms of long tasks between two performance.now() timestamps
export const mainThreadBusyMs = (from, to) => {
  // the callback gets entries asynchronously, so the long task that has just delayed a response is still in the buffer
  longTasks.push(...observer.takeRecords());
  while (longTasks.length && longTasks[0].startTime + longTasks[0].duration < to - KEEP_MS) {
    longTasks.shift();
  }
  return longTasks.reduce(
    (sum, t) => sum + Math.max(0, Math.min(to, t.startTime + t.duration) - Math.max(from, t.startTime)),
    0,
  );
};
